
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Logo from "../assets/img/logo.png";
import { useState } from 'react';
import {toast, ToastContainer} from 'react-toastify';

const Login = () => {

  let [data, setData] = useState({
    username: "",
    password: ""
  });

  const navigate = useNavigate();


  function handleChange(e) {
    e.preventDefault();
    setData({ ...data, [e.target.id]: e.target.value });
  }

  const loginClick = (e) => {
    e.preventDefault();
    if (data.username === "admin" && data.password === "admin") {
      localStorage.setItem("usertype", "admin");
      localStorage.setItem("id", "1");
      toast.success("Login Success!")
      
      
      
      navigate('/admin/dashboard');
    }
    else {
      
      toast.error("Invalid credentials");
    }
  } 

  return (
    <>
      <main>
      <ToastContainer />
        <div className="container">

          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                  <div className="d-flex justify-content-center py-4">
                    <Link to='/ '>
                      <a href="index.html" className="logo d-flex align-items-center w-auto">
                        <img src={Logo} alt="" />
                        <span className="d-none d-lg-block">Sales Dashboard</span>
                      </a>
                    </Link>
                  </div>
                  {/* <!-- End Logo --> */}

                  <div className="card mb-3">

                    <div className="card-body">

                      <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                      </div>

                      <div className="row g-3 needs-validation">

                        <div className="col-12">
                          <label for="yourUsername" className="form-label">Username</label>
                          <div className="input-group has-validation">
                            <span className="input-group-text" id="inputGroupPrepend">@</span>
                            <input type="text" id="username" className="form-control" onChange={(e) => { handleChange(e) }} value={data.username} required />
                            <div className="invalid-feedback">Please enter your username.</div>
                          </div>
                        </div>

                        <div className="col-12">
                          <label for="yourPassword" className="form-label">Password</label>
                          <input type="password" id="password" className="form-control" onChange={(e) => { handleChange(e) }} value={data.password} required />
                          <p className='font-size-sm text-danger' id='customError'></p>
                          <div className="invalid-feedback">Please enter your password!</div>
                        </div>
                        <div className="col-12">
                          <button className="btn btn-primary w-100" onClick={(e) => { loginClick(e) }}>Login</button>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>

          </section>

        </div>
      </main>
    </>
  )
}

export default Login;